"use client";

import Button from "@/components/Button/Button";
import { useRouter } from "next/navigation";
import "./CTAButtons.scss";
import { IoPlayCircleOutline } from "react-icons/io5";
import { useState } from "react";
import ContactFormModal from "../ContactFormModal/ContactFormModal";

const CTAButton = ({
  primaryText = "Get Started Free",
  secondaryText = "View Demo",

  primaryVariant = "secondary",
  secondaryVariant = "outline",

  primarySize = "lg",
  secondarySize = "lg",

  primaryClassName = "get-started-btn",
  secondaryClassName = "video-btn",

  secondaryOnClick,
  secondaryLink = "/contact",
  onGetStartedClick,
}) => {
  const router = useRouter();

  const handleSecondaryClick = () => {
    if (secondaryOnClick) {
      secondaryOnClick();
    } else {
      router.push(secondaryLink);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (onGetStartedClick) {
      onGetStartedClick();
    } else {
      setShowModal(true);
    }
  };

  const showVideoIcon =
    secondaryText?.toLowerCase().includes("demo") ||
    secondaryText?.toLowerCase().includes("watch");

  return (
    <div className="button-container">
      <Button
        variant={primaryVariant}
        size={primarySize}
        className={primaryClassName}
        onClick={handleClick}
      >
        {primaryText}
      </Button>

      <Button
        variant={secondaryVariant}
        size={secondarySize}
        className={secondaryClassName}
        onClick={handleSecondaryClick}
      >
        {showVideoIcon && <IoPlayCircleOutline className="video-icon" />}
        {secondaryText}
      </Button>
      <ContactFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => setShowModal(false)}
      />
    </div>
  );
};

export default CTAButton;
